import { Image, ImageProps } from 'expo-image';
import { Link } from 'expo-router';
import { Pressable, StyleSheet } from 'react-native';

export type PastramiReubenCardProps = Omit<ImageProps, 'children' | 'source'> & {
  pickUpHref: string;
};

export function PastramiReubenCard({ pickUpHref, ...imageProps }: PastramiReubenCardProps) {
  return (
    <Link href={pickUpHref} asChild>
      <Pressable>
        <Image
          alt="Pastrami Reuben. Limited Time Only. Pastrami, Melted Swiss Cheese, Sweet & Tangy Slaw, Thousand Island Dressing & Mayo. Order now"
          source={require('./pastrami-reuben-banner.webp')}
          placeholder={{ thumbhash: 'rCgOFgbYmPd3eEiIh3mIhpinGICGIEg' }}
          {...imageProps}
          style={[styles.pastramiReuben, imageProps.style]}
        />
      </Pressable>
    </Link>
  );
}

const styles = StyleSheet.create({
  pastramiReuben: {
    aspectRatio: 1500 / 1680,
  },
});
